<template>
    <div>
        <van-tabbar v-model="active2">
            <van-tabbar-item icon="home-o" @click="go('/fsHome')">资源</van-tabbar-item>
            <van-tabbar-item icon="search">消息</van-tabbar-item>
            <van-tabbar-item icon="plus" @click="show=!show"></van-tabbar-item>
            <van-tabbar-item icon="friends-o">会议</van-tabbar-item>
            <van-tabbar-item icon="contact" @click="go('/my')">我的</van-tabbar-item>
        </van-tabbar>
        <van-popup
                v-model="show"
                position="bottom"
                :style="{ height: '18%' }">
            <div style="line-height: 66px;">
                <div style="float: left">
                    <van-button color="#43D7B5" icon="add-o" type="primary" round /><br/>
                    <p style="font-size: 10px;margin-top: -32px;margin-left: 30px;">发布资源</p>
                </div>
                <div style="float: left">
                    <van-button color="#6DD400" icon="edit" type="primary" round /><br/>
                    <p style="font-size: 10px;margin-top: -32px;margin-left: 28px;">发布问题</p>
                </div>
                <div style="float: left">
                    <van-button color="#F7B500" icon="cash-back-record" type="primary" round /><br/>
                    <p style="font-size: 10px;margin-top: -32px;margin-left: 29px;">发布悬赏</p>
                </div>
                <div style="float: left">
                    <van-button color="#F56502" icon="contact" type="primary" round /><br/>
                    <p style="font-size: 10px;margin-top: -32px;margin-left: 30px;">我的发布</p>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import {
    Tabbar,
    TabbarItem,
    Popup,
    Button,

} from 'vant';
import {} from "@/api/dictionary";
import {} from "@/utils/sessionStorage.js"
export default {
  data() {
    return {
        active2:0,
        show: false,
    };
  },
  filters: {
    
  },
  components: {
      [Tabbar.name]:Tabbar,
      [TabbarItem.name]:TabbarItem,
      [Popup.name]:Popup,
      [Button.name]:Button,
  },
  methods: {
	 go(to){
	     this.$router.push({path:to});
     }
  },
  computed: {
    
  },
  watch:{
	
  },
  mounted() {
	  
  }

}
</script>